<template>
    <header id="koreit-header"
        :class="{ active: state.isMenuActive }">
        <h1 id="koreit-logo"><a href="/main.html" title="메인으로 이동"><span class="text_hidden">한국토지신탁</span></a></h1>
        
        <!-- 상단 메뉴 -->
        <nav id="koreit-gnb">
            <MenuNavigation
                :menuNavigationType="1"
                :onRootMenuClick="eventHandler.onRootMenuClick"
                :onTwoDepthMenuClick="eventHandler.onTwoDepthMenuClick"
                :onRootMenuMouseOver="eventHandler.onRootMenuMouseOver"
                :onRootMenuMouseOut="eventHandler.onRootMenuMouseOut" />
        </nav>

        <!-- 검색, 국문, 영문 버튼 영역 -->
        <div class="h-util">
            <ul class="h-lang">
                <li class="on"><a href="#" @click="eventHandler.onKorButtonClick" title="KOR">KOR</a></li>
                <li><a href="#" @click="eventHandler.onEngButtonClick" title="ENG">ENG</a></li>
            </ul>
            <button v-if="state.isKorMenuOn" type="button" title="검색" class="h-sch" @click="state.isSearchOn = true">
                <span class="text_hidden">검색</span>
            </button>
        </div>
        <button type="button" id="menuToggle" @click="state.isMenuActive = state.isMenuActive ? false : true"><span></span><span></span><span></span></button>

        <!-- 메뉴 맵 -->
        <div id="all-gnb">
            <MenuNavigation
            :onRootMenuClick="eventHandler.onRootMenuClick"
            :menuNavigationType="2"
            :onTwoDepthMenuClick="eventHandler.onTwoDepthMenuClick"
            :onThreeDepthMenuClick="eventHandler.onThreeDepthMenuClick" 
            :onSideButtonClick="eventHandler.onSideButtonClick" />
        </div>
    </header>

    <!-- 상단 검색 영역 -->
    <div :class="[
        { 'header-sch': true },
        { on: state.isSearchOn }
    ]">
        <div>
            <input type="text" placeholder="검색어를 입력해 주세요" @keyup.enter="eventHandler.onSearchClick" v-model="state.searchKeyword">
            <button type="submit" title="검색" @click="eventHandler.onSearchClick">
                <span class="text_hidden">검색</span>
            </button>
        </div>
        <button type="button" title="검색 닫기" class="sch-close" @click="state.isSearchOn = false">
            <span class="text_hidden">검색 닫기</span>
        </button>
    </div>
    
    <!-- 국문 메뉴 -->
    <!-- <div v-if="state.isKorMenuOn" :class="[
        { 'sub-menu-wrap': true },
        { on: state.isThreeDepthMenuOn }, 
    ]">
        <div class="s-inner">
            <div class="tit">
                <h3>{{ !!state.selectedTwoDepthMenuInfo ? state.selectedTwoDepthMenuInfo.title : '' }}</h3>
                <button type="button" title="메뉴 열기" @click="state.isThreeDepthMenuOn = state.isThreeDepthMenuOn ? false : true">
                    <span class="text_hidden">메뉴 열기</span>
                </button>
            </div>
            <ul v-if="state.selectedTwoDepthMenuInfo">
                <li v-for="childMenuInfo in state.selectedTwoDepthMenuInfo.children" v-bind:key="childMenuInfo"
                    :class="{ on: !!state.selectedThreeDepthMenuInfo && childMenuInfo.title === state.selectedThreeDepthMenuInfo.title }">
                    <router-link
                        :to="childMenuInfo.path"
                        :title="childMenuInfo.title"
                        @click="eventHandler.onThreeDepthMenuClick(3, state.selectedRootMenuInfo, state.selectedTwoDepthMenuInfo, childMenuInfo)">{{childMenuInfo.title}}</router-link>
                </li>
            </ul>
        </div>
    </div> -->

    <!-- 메인 컨텐츠 영역 -->
    <div class="content">
        <div>
            <div>
                <div id="mVisu">
                    <div class="mVisu_slide">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="img_box mVisu1"></div>
                                <div class="txt_box">
                                    <p class="tit">한국토지신탁의 <strong>오늘</strong>이 쌓여<br>대한민국 부동산금융의 <strong>역사</strong>가 됩니다.</p>
                                    <p class="txt">한국토지신탁은 날마다 새 역사를 쓰고 있습니다.<br class="mo_br">업계 선두주자로서의 책임감과 끝없는 혁신으로<br class="mo_br">한국토지신탁은 매일 새롭게 성장하고 있습니다.</p>
                                    <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU1101')" title="한국토지신탁 소개">한국토지신탁 소개</a>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="img_box mVisu2"></div>
                                <div class="txt_box">
                                    <p class="tit">부동산의 <strong>시작</strong>과 <strong>끝</strong>에 한국토지신탁이 있습니다.</p>
                                    <p class="txt">토지개발부터 재개발‧재건축사업, 리츠(REITs)에 이르기까지<br class="mo_br">부동산의 전 생애주기에 발맞춰<br class="mo_br">차별화된 사업구도와 최적의 상품 구성을 제시합니다.</p>
                                    <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU2101')" title="신탁사업 소개">신탁사업 소개</a>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="img_box mVisu3"></div>
                                <div class="txt_box">
                                    <p class="tit">국내 <strong>대표</strong> 부동산전문가그룹이 고객과 함께합니다.</p>
                                    <!-- <p class="txt">부동산금융 전문지식과 노하우, 책임감으로 무장한<br class="mo_br">한국토지신탁만의 ‘맨파워’가 고객의 성공을 위해 최선을 다합니다.</p> -->
                                    <p class="txt">전문지식과 노하우, 책임감으로 무장한 맨파워로<br class="mo_br">한국토지신탁은 고객의 성공을 위해 최선을 다합니다.</p>
                                    <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU3101')" title="신탁방식 도시정비사업 소개">신탁방식 도시정비사업 소개</a>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="img_box mVisu4"></div>
                                <div class="txt_box">
                                    <p class="tit">내 마음대로 편안하게<br><strong>생전에 미리 설계합니다.</strong></p>
                                    <p class="txt">맞춤형 설계로 당신의 부동산과 뜻을 지켜드립니다.
                                        <br class="mo_br">생전에 미리미리 계획적으로 관리하고, 내 뜻대로 안전하게 이전합니다.
                                        <br class="mo_br">불필요한 분쟁을 예방하는 솔루션, 한국토지신탁이 함께 합니다.
                                    </p>
                                    <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU6101')" title="유언대용신탁 소개">유언대용신탁 소개</a>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-pagination"></div>
                        <div class="swiper-scrollbar"></div>
                    </div>
                    <div class="btn_box">
                        <button type="button" title="슬라이드 정지" class="stop on"><i class="fa-regular fa-pause"></i></button>
                        <button type="button" title="슬라이드 재생" class="play"><i class="fa-regular fa-play"></i></button>
                    </div>
        
                    <div class="scroll_box">
                        <p>SCROLL DOWN</p>
                        <i class="fa-light fa-computer-mouse-scrollwheel"></i>
                    </div>
                </div>
            </div>
            <div>
                <div id="mGrowth">
                    <div class="inner">
                        <p class="en">KOREIT</p>
                        <div class="main_title">
                            <!-- <h2><strong>숫자가 아닙니다.</strong><br>고객의 자산을 믿고 맡기실 수 있는 든든한 발판입니다.</h2> -->
                            <h2><strong>Preview</strong></h2>
                        </div>
                        <div class="img_box"></div>
                        <ul>
                            <li v-for="item in state.portfolioBusinessItems">
                                <dl>
                                    <dt>{{item.BizContent}}</dt>
                                    <dd>
                                        <span :id="`counter${item.SortOrder}`" :class="item.IsbizResultYear ? 'num year' : 'num number'">{{item.BizResultNumber[0]}}</span>{{item.BizResultText[0]}} 
                                        <span v-if="item.BizResultNumber[1]" :id="`counter${item.SortOrder+'-1'}`" class="num number">{{item.BizResultNumber[1]}}</span>{{item.BizResultText[1]}}
                                    </dd>
                                    <dd class="txt2">{{item.BizBase}}</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div id="mBusiness">
                    <div>
                        <div class="img_box img1"></div>
                        <div class="txt_box">
                            <h2>신탁사업</h2>
                            <p>풍부한 개발경험과 철저한 리스크 관리, 사업분석을 통해<br>고객님의 자산가치를 최대로 키워드리고 있습니다.</p>
                            <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU2101')">자세히 보기</a>
                        </div>
                    </div>
                    <div>
                        <div class="img_box img3"></div>
                        <div class="txt_box">
                            <h2>도시정비사업</h2>
                            <p>사업기간 단축, 효율적 자금운용,<br>투명한 사업관리로 주거와 도시의 품격을 높입니다.</p>
                            <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU3101')">자세히 보기</a>
                        </div>
                    </div>
                    <div>
                        <div class="img_box img2"></div>
                        <div class="txt_box">
                            <h2>REITs</h2>
                            <p>업계 최초 진출! 오랜 경험과 다양한 포트폴리오를<br>기반으로 투자기회를 확대하고 수익으로 보답합니다.</p>
                            <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU4101')">자세히 보기</a>
                        </div>
                    </div>
                    <div>
                        <div class="img_box img4"></div>
                        <div class="txt_box">
                            <h2>유언대용신탁</h2>
                            <p>전문 부동산신탁사의 맞춤형 신탁 설계로<br> 고객님의 삶과 가족의 미래를 든든하게<br> 지켜드립니다.</p>
                            <a href="#" @click="eventHandler.onFooterMenuClick($event, 'KOR-MENU6101')">자세히 보기</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 퀵버튼 영역 -->
    <div id="Quick">
        <ul>
            <li><a href="/land-trust/move-In-Info/payment" title="분양대금 조회"><i class="fa-light fa-circle-dollar-to-slot"></i></a></li>
            <li><a href="/land-trust/sale/short-notice" title="공매공고"><i class="fa-light fa-house-building"></i></a></li>
            <li><a href="/company/way-to-come/map" title="오시는 길"><i class="fa-light fa-location-dot"></i></a></li>
            <li><a href="/company/service-center/advice" title="고객의 소리 "><i class="fa-light fa-headset"></i></a></li>
        </ul>
    </div>

    <!-- 팝업 영역 -->
    <div v-show="state.isPopupActive" class="popup-wrap">
        <div class="popup-inner1">
            <div class="popup-slide">

                <div class="swiper-wrapper">
                    <div v-for="item in state.popupItems" v-bind:key="item" class="swiper-slide">
                         <a :href="item.PopupPath" target="_blank"><img :src="`AttachFiles${item.FilePath}`"></a> 
                        <!--<a href="javascript:;" @click="methods.goPOPUP(item.PopupPath)"><img :src="`AttachFiles${item.FilePath}`"></a>-->
                    </div>
                </div>

                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-pagination"></div>
            </div>
            
            <div class="popup-bottom">
                <a href="javascript:;" @click="eventHandler.setCookie()" title="오늘 하루 그만보기" class="today-btn">오늘 하루 그만보기</a>
                <a href="javascript:;" @click="state.isPopupActive = false" title="닫기" class="popup-close">닫기</a>
            </div>
        </div>
    </div>
    
    <!-- 푸터 영역 -->
    <Footer :isKorMenuOn="state.isKorMenuOn" :onFooterMenuClick="eventHandler.onFooterMenuClick" />
</template>
<script>
import { onMounted, reactive, ref } from '@vue/runtime-core';
import { fieldInfo } from '@/modules/land-trust/field-info.js';
import { krtBoardCommon } from '@/modules/krt-board-common.js';
import { portfolio } from '@/modules/ir-pr-center/portfolio.js';
// swiper 라이브러리 (우선은 4.5.0 버전 사용 필수!!)
import Swiper from 'swiper/dist/js/swiper.js';
import { useStore } from 'vuex';
import { menuType, menuDataSource } from '@/modules/menu-management.js';
import MenuNavigation from '@/components/MenuNavigation.vue';
import Footer from '@/components/Footer.vue';
import vueCookieManager from "@/utils/vue-cookie-manager";
export default {
    components: {
        MenuNavigation,
        Footer,
    },
    setup() {

        // 최상단 메뉴 ref
        const topMenu = ref(null);

        // 메뉴맵 ref
        const menuMap = ref(null);

        // 스토어
        const store = useStore();

        // state (변수)
        const state = reactive({

            // 국문메뉴 on 여부
            isKorMenuOn: true,

            // 영문메뉴 on 여부
            isEngMenuOn: false,

            // 검색영역 on 여부
            isSearchOn: false,

            // 상단 메뉴영역 active 여부
            isMenuActive: false,

            // 팝업 활성 여부
            isPopupActive: false,

            // 팝업 목록
            popupItems : [],

            // 공매공고 목록 (최근 6건)
            shortNoticeItems: [],

            // 입주정보 목록 (최근 6건)
            // moveinNoticeItems: [],

            // 현장정보 목록 (최근 6건)
            fieldNoticeItems: [],

            // 포토폴리오 사업실적 목록 
            portfolioBusinessItems: null,

            // 공매정보 메뉴 활성화 여부
            isActiveShortNotice: false,

            // 입주정보 메뉴 활성화 여부
            isActiveMoveinInfo: false,

            // 현장정보 메뉴 활성화 여부
            isActiveFieldInfo: false,

            // 검색 키워드
            searchKeyword: null,

            // 현장정보 파라미터
            parameter: {

                Product: '', 

                Parea01: '', //todo : 추후 지도에서 선택한 값 바인딩 되도록 개발 필

                Pname: '', 

                CurPage: fieldInfo.currentPage,

                // 목록 크기
                ListSize: fieldInfo.listSize,

                vflag_koreit: 'C',
                
                vflag_koaroo: '',
            },
        });

        // 이벤트 핸들러
        const eventHandler = {

            /**
             * 검색 이벤트 처리
             */
            onSearchClick: () => {

                location.href = `/others/total-search?keyword=${state.searchKeyword}`;
            },

            /**
             * 국문 메뉴 버튼 클릭 이벤트 처리
             */
            onKorButtonClick: event => {

                // a tag 이벤트 막기
                event.preventDefault();
            },

            /**
             * 영문 메뉴 버튼 클릭 이벤트
             */
            onEngButtonClick: event => {

                // a tag 이벤트 막기
                event.preventDefault();

                // 메뉴유형값 설정 (session storage)
                sessionStorage.setItem('menuType', menuType.eng);

                // 영문 메인화면으로으로 이동
                location.href = '/eng-main.html';
            },

            /**
             * footer 메뉴 클릭 이벤트 처리 (이메일주소 무단수집거부, 개인정보취급방침, 이용약관, 온라인상담)
             */
            onFooterMenuClick: (event, menuId, NotPolicy = true) => {
                
                if (NotPolicy) {
                    // 메뉴화면 이동
                    location.href = menuDataSource.find(data => data.menuId === menuId).path;
                } else {
                    location.href = menuDataSource.find(data => data.menuId === menuId).path +'#privacy-policy';
                }
                
            },

            /**
             * 최상위 메뉴 클릭 이벤트 처리
             * @param {any} event
             * @param {Number} menuNavigationType : 메뉴 네비게이션 유형 (1: 상단 메뉴영역, 2: 메뉴맵, 3: 사이트맵 페이지 내 메뉴 맵)
             * @param {Object} menuInfo : 메뉴 정보
             */
            onRootMenuClick: (event, menuNavigationType, menuInfo) => {
                
                // a tag 이벤트 막기
                event.preventDefault();
                event.target.parentNode.classList.toggle('on');
            },

            /**
             * 2뎁스 메뉴 클릭 이벤트 처리
             * @param {any} event
             * @param {Number} menuNavigationType : 메뉴 네비게이션 유형 (1: 상단 메뉴영역, 2: 메뉴맵, 3: 사이트맵 페이지 내 메뉴 맵)
             * @param {Object} rootMenuInfo : 최상위 메뉴 정보
             * @param {Object} menuInfo : 메뉴 정보
             */
            onTwoDepthMenuClick: (event, menuNavigationType, rootMenuInfo = null, menuInfo = null) => {

                // 메뉴 네비게이션 유형이 상단 메뉴영역 && 메뉴정보들이 없을 시 (+버튼 클릭 시)
                if (menuNavigationType === 1 && !rootMenuInfo && !menuInfo) {

                    // 현재 메뉴 toggle on 여부
                    const isOn = event.target.parentNode.classList.value.includes("on");

                    // 3뎁스 메뉴 element 목록
                    const threeDepthMenuAreaElements = event.target.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.depth3');
                    
                    // 이전 메뉴영역 닫기
                    threeDepthMenuAreaElements.forEach(element => element.classList.remove('on'));

                    // 현재 메뉴영역 toggle on (on 상태면 off)
                    isOn ? event.target.parentNode.classList.toggle('off') : event.target.parentNode.classList.toggle('on');
                }
            },

            /**
             * 모바일버전 2뎁스 메뉴 화살표 클릭 이벤트 처리
             * @param {any} event
             */
             onSideButtonClick: (event) => {
                
                event.target.parentNode.parentNode.classList.toggle('on');
            },

            /**
             * 최상위 메뉴 마우스 오버 이벤트 처리
             */
            onRootMenuMouseOver: () => {

                document.getElementById("koreit-header").classList.add('on');
            },

            /**
             * 최상위 메뉴 마우스 아웃 이벤트 처리
             */
            onRootMenuMouseOut: () => {

                document.getElementById("koreit-header").classList.remove('on');
            },

            /**
             * 하단 카드 클릭시 해당 경로로 이동
             */
            onCardClick: (type, pram) => {

                event.preventDefault();
                
                if (type === '1') {
                    location.href = `/land-trust/sale/short-notice-detail?Seq=${pram}`;
                }

                else if (type === '2') {
                    location.href = `/land-trust/move-In-Info/construction-view?idx=${pram}`;
                }
            },

            /**
             * 오늘하루 보지않기 이벤트 핸들러(쿠키 설정)
             */
            setCookie: () => {

                vueCookieManager.setCookie('popup', true, 1 )
                state.isPopupActive = false;
            }
        }

        const methods = {

            /**
             * 게시판 목록 가져오기
             */
            getBoardItems: () => {

                // 공매공고 최근 6건 조회
                krtBoardCommon.getKRTBoardContentList('ADM', 'KRTCM006', null, null).then(boardItems => {

                    state.shortNoticeItems = new Array();
                    for (let index = 0; index < 6; index++) state.shortNoticeItems.push(boardItems[index]);
                }).finally(() => {

                    // 공매정보 최초 진입시 보여주기
                    state.isActiveShortNotice= true;
                });
            },

            // 현장 정보 목록 조회 - 하단 썸네일
            getFieldNoticeItemsList: () => {
                
                // 현장 정보 6건 조회
                fieldInfo.getProjectByMain(null).then(field => {

                    // 현장 정보 6건 조회
                    state.fieldNoticeItems = new Array();
                    if (!!field) for (let index = 0; index < 6; index++) state.fieldNoticeItems.push(field[index]);

                }).finally(() => {

                    state.fieldNoticeItems.forEach((item)=>{

                        // 주소 텍스트 가공 
                        if (!!item.addr1) {
                            item.addr1 += ` ${item.addr2}`;
                        }
                    });
                });
            },
            /**
             * 포토폴리오 사업실적 목록 가져오기
             */
            getBusinessPortfolioItems: () => {

                portfolio.getBusinessPortfolioItems().then(portfolioBusinessItems => {
                    
                    // 사업실적 텍스트 가공 

                    let bizResultTextindex;

                    let bizResultTextindex1;

                    if (!!portfolioBusinessItems) {
                        
                        portfolioBusinessItems.forEach(row => {

                            row.BizResultText = [];

                            row.BizResultNumber = [];

                            // 사업실적 년 포함여부
                            row.IsbizResultYear = row.BizResult.includes('년');

                            if (row.IsbizResultYear) {

                                // 사업실적 년 텍스트 인덱스 찾기
                                bizResultTextindex = row.BizResult.indexOf('년');

                                // 사업실적 년 텍스트 바인딩
                                row.BizResultText.push('년');

                                // 사업식적 년 숫자값 바인딩
                                row.BizResultNumber.push(row.BizResult.substring(0, bizResultTextindex).split(' ').join(''));
                            } else {
                                if(row.SortOrder == 4){
                                // 사업실적 억원단위 텍스트 인덱스 찾기
                                bizResultTextindex = row.BizResult.indexOf('세대');

                                // 사업실적 억원 텍스트 바인딩
                                row.BizResultText.push('세대');

                                row.BizResultNumber.push(row.BizResult.substring(0, bizResultTextindex).split(' ').join(''));

                            }else{
                                // 조단위 까지 있는경우
                                if (row.BizResult.includes('조')) {
                                    
                                    // 사업실적 조단위 텍스트 인덱스 찾기
                                    bizResultTextindex = row.BizResult.indexOf('조');

                                    // 사업실적 억원단위 텍스트 인덱스 찾기
                                    bizResultTextindex1 = row.BizResult.indexOf('억원');

                                    // 사업실적 조 텍스트 바인딩
                                    row.BizResultText.push('조');

                                    // 사업실적 억원 텍스트 바인딩
                                    row.BizResultText.push('억원');

                                    // 사업식적 조 숫자값 바인딩
                                    row.BizResultNumber.push(row.BizResult.substring(0, bizResultTextindex).split(' ').join(''));

                                    // 사업식적 억원 숫자값 바인딩
                                    row.BizResultNumber.push(row.BizResult.substring(bizResultTextindex+1, bizResultTextindex1).split(' ').join(''));
                                } 
                                // 억단위 까지 있는경우
                                else {

                                    // 사업실적 억원단위 텍스트 인덱스 찾기
                                    bizResultTextindex = row.BizResult.indexOf('억원');

                                    // 사업실적 억원 텍스트 바인딩
                                    row.BizResultText.push('억원');

                                    // 사업식적 억원 숫자값 바인딩
                                    row.BizResultNumber.push(row.BizResult.substring(0, bizResultTextindex).split(' ').join(''));
                                }
                            }
                            }

                        });
                        
                        // 화면 표시여부 Y인 리스트만 받아오기 
                        state.portfolioBusinessItems = portfolioBusinessItems.filter(row => row.DspYN == 'Y');
                    }
                }).finally(() => {
                    // 디자인 초기화
                    methods.designInit();
                });
            },
            /**
             * 디자인 초기화 
             * -> 디자인루니에서 제공한 스크립트 우선은 사용 함 (100% 동일하진 않음, 리펙토링 가능하면 할 것!!)
             */
            designInit: () => {

                const mVisuSwiper = new Swiper(".mVisu_slide", {
                    effect: 'fade',
                    pagination: {
                        el: ".swiper-pagination",
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    scrollbar: {
                        el: ".swiper-scrollbar",
                        hide: false,
                    },
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false,
                    },
                });

                const stopBtn = document.querySelector('.btn_box .stop');
                const playBtn = document.querySelector('.btn_box .play');
                stopBtn.addEventListener("click", function(){
                    stopBtn.classList.remove("on")
                    playBtn.classList.add("on")
                    mVisuSwiper.autoplay.stop();
                })
                playBtn.addEventListener("click", function(){
                    playBtn.classList.remove("on")
                    stopBtn.classList.add("on")
                    mVisuSwiper.autoplay.start();
                })

                var swiper = new Swiper(".mNotice_slide", {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 2,
                            spaceBetween: 5,
                        },
                        500: {
                            slidesPerView: 1,
                            spaceBetween: 5,
                        },
                    }
                });

                var swiper1 = new Swiper(".mNotice_slide2", {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "progressbar",
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 2,
                            spaceBetween: 5,
                        },
                        500: {
                            slidesPerView: 1,
                            spaceBetween: 5,
                        },
                    }
                });

                function numberCounter(target_frame, target_number) {
                    target_number = target_number.replace(",", "");
                    this.count = 0; this.diff = 0;
                    this.target_count = parseInt(target_number);
                    this.target_frame = document.getElementById(target_frame);
                    this.timer = null;
                    this.counter();
                };
                numberCounter.prototype.counter = function() {
                    var self = this;
                    this.diff = this.target_count - this.count;
                    
                    if(this.diff > 0) {
                        self.count += Math.ceil(this.diff / 5);
                    }
                    
                    if (this.target_frame.classList.contains("year")){
                        this.target_frame.innerHTML = this.count.toString()
                    } else {
                        this.target_frame.innerHTML = this.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                    
                    if(this.count < this.target_count) {
                        this.timer = setTimeout(function() { self.counter(); }, 20);
                    } else {
                        clearTimeout(this.timer);
                    }
                };

                const header = document.getElementById("koreit-header")
                const moveCtn = document.querySelector(".content > div")
                const moveContent = document.querySelectorAll(".content > div > div")
                let moveIndex = 0
                let animate = false
                let footer = false;

                window.scrollTo({top:0})

                document.querySelector("#koreit-footer .go-top").addEventListener("click", function(){
                    moveIndex = 0;
                    moveCtn.style.transform = "translateY(0)";
                    window.scrollTo({ top: 0, behavior: "smooth" }); 
                })

                window.onmousewheel = function(e){
                    if (animate == false && window.innerWidth > 1024){
                        if (e.wheelDelta > 20){
                            if (footer == false){
                                if (moveIndex > 0){
                                    moveIndex--;    
                                    moving(moveIndex);
                                }
                            } else {
                                window.scrollTo({top:0})
                                setTimeout(function(){
                                    footer = false;
                                }, 500)
                            }
                        } else if (e.wheelDelta < -20){
                            if (moveIndex < moveContent.length - 1){
                                moveIndex++    
                                moving(moveIndex);
                            } else if (moveIndex == moveContent.length - 1){
                                footer = true;
                                window.scrollTo({top:window.innerHeight})
                            }
                        }
                    }
                }

                function moving(index){
                    animate = true;
                    window.scrollTo({top:0})

                    moveCtn.style.transform = "translateY("+ -(window.innerHeight * index) +"px)";

                    if (index == 1 || index == 4 || index == 5) {
                        header.classList.add("scroll-on")
                    } else {
                        header.classList.remove("scroll-on")
                    }

                    if (index == 1){
                        setTimeout(function(){
                            const numCount = document.querySelectorAll("#mGrowth ul li dl dd .num");
                            numCount.forEach((v)=>{
                                new numberCounter(v.id, v.innerHTML)
                            })
                        }, 500)
                    }

                    setTimeout(function(){
                        animate = false;
                    }, 1000)
                }
            },

            /**
             * 메인페이지 팝업 조회 메서드
             */
            getPopupZon: () => {

                // 메인 화면 팝업 조회
                krtBoardCommon.getPopupZon('POPUPZONE').then(result => {

                    if (result.length > 0) {

                        state.popupItems = result
                        state.isPopupActive = true
                    }
                }).finally(() => {

                    // 메인팝업 swiper 스타일 설정
                    const swiper3 = new Swiper(".popup-slide", {
                        loop: true,
                        autoHeight: true,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            type: "fraction",
                            formatFractionCurrent: (number) => {
                                return (`0${number}`).slice(-2);
                            },
                            formatFractionTotal: (number) => {
                                return (`0${number}`).slice(-2);
                            },
                            renderFraction: (currentClass, totalClass) => {
                                return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`
                            }
                        },
                    });
                });
            },

            // 24.1.14 수정 이후 사용하지 않으나 기존 코드가 사용될 경우를 위해 삭제하지 않습니다.
            goPOPUP: (link) => {
                window.open(link);
            },
        }

        // Dom객체 그려진 이후
        onMounted(() => {
            // 국문 메뉴유형 설정 (session storage)
            sessionStorage.setItem('menuType', menuType.kor);

            //포토폴리오 사업실적 목록 초기조회
            methods.getBusinessPortfolioItems();

            // 최초 디자인 관련 초기화
            methods.designInit();

            // 오늘 하루 보지않기 쿠기 여부에 따른 팝업 조회 설정
            if (vueCookieManager.getCookie('popup') !== 'true') methods.getPopupZon();

            // 게시판 목록 가져오기
            // methods.getBoardItems();

            // 현장 정보 목록 조회 - 하단 썸네일
            // methods.getFieldNoticeItemsList();

            state.isKorMenuOn = true;
            state.isEngMenuOn = false;

            // 스크롤 이벤트 설정
            document.addEventListener('scroll', () => {

                const koreitHeaderElement = document.getElementById("koreit-header");

                if (document.documentElement.scrollTop > 0) {

                    if (!koreitHeaderElement.classList.contains('scroll-on')) {

                        koreitHeaderElement.classList.add('scroll-on');
                    }
                }
                else koreitHeaderElement.classList.remove('scroll-on');
            });
        });
    
        return {
            state,
            eventHandler,
            methods,
            topMenu,
            menuMap,
        }
    },
}
</script>
<style>
    html, body{overflow-y:hidden}

    @media screen and (max-width:1024px){
        html, body {overflow-y:auto}
    }

    #koreit-gnb > ul > li > ul > li > ul > li > router-link {
        display: block;
        width: 100%;
        font-size: 0.875em;
        color: #666;
        padding: 4px 0 4px 13px;
        position: relative;
    }

    #all-gnb > ul > li > ul > li > ul > li > router-link {
        display: block;
        width: 100%;
        font-size: 0.875em;
        color: #666;
        padding: 4px 0 4px 13px;
        position: relative;
    }

    #all-gnb > ul > li > ul > li > ul > li > router-link:before {
        content: '-';
        font-weight: 600;
        position: absolute;
        left: 0;
        top: 4px;
    }
</style>
